import React from "react";
import { Accordion } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { AccordionSkeleton } from "../../components";
import { ApiHelper, PlaylistInterface, ToastHelper } from "../../helpers";

interface Props {
  refreshKey: string
}

export const PlaylistsSidebar: React.FC<Props> = props => {
  const location = useLocation();
  const [playlists, setPlaylists] = React.useState<PlaylistInterface[]>(null);
  const [selectedPlaylist, setSelectedPlaylist] = React.useState<PlaylistInterface>(null);

  const init = () => {
    ApiHelper.get<PlaylistInterface[]>("/playlists")
      .then((data) => setPlaylists(data || []))
      .catch(err => {
        console.error("Failed to load playlists:", err);
        ToastHelper.error("Failed to load playlists");
      });
  }

  const updateSelected = () => {
    let result: PlaylistInterface = null;
    const parts = window.location.href.split("?")[0].split("/");
    const id = parseInt(parts[parts.length - 1]);
    playlists?.forEach(p => { if (p.id === id) result = p; })
    setSelectedPlaylist(result);
  }

  React.useEffect(init, [props.refreshKey])
  React.useEffect(updateSelected, [playlists, location.pathname]) //eslint-disable-line

  const getPlaylistRows = (playlistType: string) => {
    const result: React.ReactElement[] = [];

    const filtered = (playlistType === "feed")
      ? playlists?.filter(p => p.subscriptionId > 0)
      : playlists?.filter(p => !(p.subscriptionId > 0));

    filtered?.forEach(p => {
      let className = (p.id === selectedPlaylist?.id) ? "active" : "";
      result.push(
        <li key={"p" + p.id} className="nav-item">
          <Link className={className} to={"/playlists/" + p.id}>{p.name || "(No name)"}</Link>
        </li>
      );
    });
    return <ul className="nav flex-column">{result}</ul>;
  }

  const getSection = (eventKey: string, title: string, addLink: string, contents: React.ReactElement) => {
    return (
      <Accordion.Item eventKey={eventKey}>
        <Accordion.Header>
          <span className="accordion-title-text">{title}</span>
          <Link
            to={addLink}
            className="sidebar-accordion-add-btn"
            title={`Create new ${title.toLowerCase()}`}
            onClick={(e) => e.stopPropagation()}
          >
            <i className="fas fa-plus"></i>
          </Link>
        </Accordion.Header>
        <Accordion.Body>{contents}</Accordion.Body>
      </Accordion.Item>
    )
  }

  const getAccordion = () => {
    if (playlists === null) return <AccordionSkeleton sections={2} />;

    const feedSection = getSection("feeds", "Feeds", "/playlists?mode=feed", getPlaylistRows("feed"));
    const customSection = getSection("custom", "Custom", "/playlists?mode=custom", getPlaylistRows("custom"));

    return (
      <Accordion id="playlistsSidebar" defaultActiveKey="custom">
        {feedSection}
        {customSection}
      </Accordion>
    );
  }

  return (
    <div className="sidebar-container">
      <div className="sidebar-header">
        <h3 className="sidebar-title">Playlists</h3>
      </div>
      <div className="sidebar-content">
        {getAccordion()}
      </div>
    </div>
  );
};